import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { MyFavoriteEventsComponent } from "./my-favorite-events/my-favorite-events.component";
import { StarredEventsService } from "../../../services/starred-events.service";
import { map, scan, shareReplay, startWith, Subject, switchMap } from "rxjs";
import { EventInfoResponseBody } from "../../../services/types/events-management-response.type";
import { AppLayoutComponent } from "../../../../shared/components/app-layout/app-layout.component";
import { PageHeaderComponent } from "../../../../shared/components/page-header/page-header.component";

@Component({
    selector: "app-my-favorite-events-container",
    imports: [
        CommonModule,
        MyFavoriteEventsComponent,
        AppLayoutComponent,
        PageHeaderComponent,
    ],
    templateUrl: "./my-favorite-events-container.component.html",
    styleUrl: "./my-favorite-events-container.component.scss"
})
export class MyFavoriteEventsContainerComponent {
  private readonly starredEventsService = inject(StarredEventsService);

  private readonly activePage$ = new Subject<number>();
  private readonly pastPage$ = new Subject<number>();

  activesResponse$ = this.activePage$.pipe(
    startWith(undefined),
    switchMap((page) => this.starredEventsService.getStarredEvents(page)),
    shareReplay(1),
  );

  activeEvents$ = this.activesResponse$.pipe(
    scan((acc, res) => [...acc, ...res.data], [] as EventInfoResponseBody[]),
  );

  activeMeta$ = this.activesResponse$.pipe(map((res) => res.meta));

  pastResponse$ = this.pastPage$.pipe(
    startWith(undefined),
    switchMap((page) =>
      this.starredEventsService.getStarredEvents(page, false),
    ),
    shareReplay(1),
  );

  pastEvents$ = this.pastResponse$.pipe(
    scan((acc, res) => [...acc, ...res.data], [] as EventInfoResponseBody[]),
  );

  pastMeta$ = this.pastResponse$.pipe(map((res) => res.meta));

  handleLoadMoreActivesClick(pageNumber: number) {
    this.activePage$.next(pageNumber);
  }

  handleLoadMorePastEventsClick(pageNumber: number) {
    this.pastPage$.next(pageNumber);
  }
}
